import Cookies from "js-cookie";

export const TOKEN_COOKIE = "tradex_security";
const EXPIRED_FLAG = "sessionExpired";

// JWT payloads are base64url; atob() needs plain base64 with padding.
// Returns null instead of throwing when the token is malformed.
export const decodeToken = (token) => {
  try {
    const payload = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    const padded = payload + "=".repeat((4 - (payload.length % 4)) % 4);
    return JSON.parse(atob(padded));
  } catch (error) {
    return null;
  }
};

// Removes the stored token. `expired` leaves a one-time notice for the login page.
export const clearSession = ({ expired = false } = {}) => {
  Cookies.remove(TOKEN_COOKIE, { path: "/" });
  try {
    if (expired) sessionStorage.setItem(EXPIRED_FLAG, "1");
  } catch (error) {
    // storage can be unavailable (private mode); the notice is optional
  }
};

export const readExpiredNotice = () => {
  try {
    return sessionStorage.getItem(EXPIRED_FLAG) === "1";
  } catch (error) {
    return false;
  }
};

export const dismissExpiredNotice = () => {
  try {
    sessionStorage.removeItem(EXPIRED_FLAG);
  } catch (error) {
    // ignore
  }
};
